import React from 'react';
import { Result, Button, Card, Typography } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const ThankyouPage = ({setPaymentDone}) => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      background: '#f4f7fe', 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '20px' 
    }}>
      <Card 
        bordered={false} 
        style={{ 
          maxWidth: 600, 
          width: '100%', 
          borderRadius: '24px', 
          boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
          textAlign: 'center',
          padding: '40px 20px'
        }}
      >
        <Result
          icon={<CheckCircleFilled style={{ color: '#05cd99', fontSize: '80px' }} />}
          title={
            <Title level={2} style={{ color: '#2b3674', marginTop: '20px' }}>
              Great Choice!
            </Title>
          }
          subTitle={
            <div style={{ marginBottom: '30px' }}>
              <Text style={{ fontSize: '18px', color: '#707eae' }}>
                Thank you for your purchase. Your subscription is now active.
              </Text>
            </div>
          }
          extra={[
            <Button 
              type="primary" 
              key="console"
              size="large"
              style={{ 
                background: '#2b3674', 
                height: '50px', 
                padding: '0 50px', 
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '600',
                border: 'none',
                boxShadow: '0 8px 16px rgba(43, 54, 116, 0.15)'
              }}
              onClick={() => setPaymentDone(false)}
            >
              Back
            </Button>
          ]}
        />
        
        <div style={{ marginTop: '30px' }}>
          <Text type="secondary" style={{ fontSize: '14px' }}>
            A confirmation email has been sent to your inbox.
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default ThankyouPage;